import { Link } from 'react-router-dom'
import useFadeIn from '@hooks/useFadeIn'
import './About.scss'

export default function About() {
  const ref = useFadeIn()

  return (
    <section className="about" id="despre">
      <div className="about-visual">
        <div className="accent-blob blob1" />
        <div className="accent-blob blob2" />
        <div className="big-wax">
          <div className="big-wax-inner">
            ✦<br />
            cu drag<br />
            și răbdare
          </div>
        </div>
      </div>

      <div className="about-text fade-up" ref={ref}>
        <div className="section-label">Povestea noastră</div>
        <h2 className="section-title about-title">
          Creat cu <em>pasiune</em>,<br />din ingrediente pure
        </h2>
        <p>
          <strong>Miss Lemon</strong> s-a născut dintr-o dragoste profundă pentru
          frumusețea simplă și pentru aromele care transformă o încăpere într-un
          sanctuar.
        </p>
        <p>
          Fiecare piesă este realizată manual, în atelierul nostru din România,
          folosind <strong>ceară naturală de soia</strong> și uleiuri esențiale de
          calitate premium.
        </p>
        <p>
          Florile uscate sunt culese și aranjate cu atenție, fiecare sachet sau wax
          melt devenind o mică operă de artă — unică, autentică, parfumată.
        </p>
        <Link to="/shop" className="btn-primary about-cta">
          Explorează produsele
        </Link>
      </div>
    </section>
  )
}
